(function() {
    'use strict';
    angular
        .module('emarket.main.post')
        .controller('PostCreateController', ['$scope', '$rootScope', '$mdPanel', '$log', '$timeout', '$q', '$state', '$stateParams', '$mdMedia', '$mdToast', '$mdDialog', '$sessionStorage', '$auth', 'StateQueue', 'File', 'Announcer', 'Post', 'Category', 'CustomField', 'Suggestion', 'Auth', 'currencies', 'provinces', 'ProvinceChooser', 'Profile', function($scope,
            $rootScope,
            $mdPanel,
            $log,
            $timeout,
            $q,
            $state,
            $stateParams,
            $mdMedia,
            $mdToast,
            $mdDialog,
            $sessionStorage,
            $auth,
            StateQueue,
            File,
            Announcer,
            Post,
            Category,
            CustomField,
            Suggestion,
            Auth,
            currencies,
            provinces,
            ProvinceChooser,
            Profile) {
            var vm = this;
            vm.post = {};
            var announcer = Announcer.createEmitter();
            var isMobile = $mdMedia('xs') || $mdMedia('sm');
            var picturePanel;

            // HACK: Add the html editor
            vm.saveFiles = function(files) {
                if (!files) {
                    return;
                }
                if ($auth.isAuthenticated()) {
                    vm.uploadFiles(files);
                } else {
                    files.forEach(function(file) {
                        Post.images.add(file);
                        vm.post.images.push({
                            pending: true
                        });
                    });
                }
            };
            if (isMobile) {
                vm.progressDiameter = 20;
                announcer.emit(Announcer.types.FULL_SCREEN_MODE_NO_TOOLBAR);
                if (!$stateParams.grabar && !$stateParams.id) {
                    $mdPanel
                        .open({
                            templateUrl: 'main/post/create/add.picture.panel.tpl.html',
                            fullscreen: true,
                            panelClass: 'post-create__add-picture__container',
                            disableParentScroll: true,
                            controllerAs: 'vm',
                            onCloseSuccess: function(panelRef, files) {
                                vm.saveFiles(files);
                            },
                            controller: [
                                'mdPanelRef',
                                function(mdPanelRef) {
                                    var vm = this;
                                    vm.choosePicture = function(files) {
                                        mdPanelRef.close(files);
                                    };
                                }
                            ]
                        })
                        .then(function(panel) {
                            picturePanel = panel;
                        });
                }
            } else {
                vm.progressDiameter = 50;
            }

            //for handling know the pending images that are uploading
            var pendingImages = 0;

            // if user clic to save and are pending message this make true
            // and inmediattly save the post
            var makeUpload = false;

            var isEditing = false;

            var moveImagesArray = function() {
                var mainImage;
                vm.post.images.forEach(function(image, i) {
                    if (image.isMain && i !== 0) {
                        mainImage = image;
                        vm.post.images.splice(i, 1);
                    }
                });
                if (mainImage) {
                    vm.post.images.unshift(mainImage);
                }
            };
            vm.user = Auth.getUser();

            vm.conditions = Post.CONDITIONS.filter(function(condition) {
                return !(isMobile && condition === 'na');
            });
            //is used to show the custom errors when the form is submitted
            vm.showCustomError = false;
            vm.currencies = currencies.sort(function(a, b) {
                if (a.symbol < b.symbol) {
                    return -1;
                }
                if (a.symbol > b.symbol) {
                    return 1;
                }
                return 0;
            });
            vm.provinces = provinces;
            //default values for post
            if ($stateParams.id) {
                Profile.getEditPost($stateParams.id)
                    .then(function(post) {
                        vm.post = Post.$buildRaw(post);
                        vm.post.province = post.province._id;
                        vm.post.currency = post.currency._id;
                        if (vm.post.custom) {
                            vm.post.custom = Object.keys(vm.post.custom).reduce(function(acc, key) {
                                acc[key] = vm.post.custom[key].value.toString();
                                return acc;
                            }, {});
                            return getCustomFields(post.categoryTree[0]._id);
                        }
                    })
                    .then(function(customFields) {
                        if (customFields) {
                            vm.customFields = customFields;
                        }
                    });
                isEditing = true;
            } else {
                var choosedProvince = ProvinceChooser.get();

                vm.post = $sessionStorage.$default({
                    currency: 'rd',
                    active: true,
                    prices: {},
                    images: [],
                    category: false,
                    action: 'sell',
                    custom: {}
                });
                if (choosedProvince && !vm.post.province) {
                    vm.post.province = choosedProvince._id;
                }
            }
            var getCustomFields = function(category) {
                if (vm.post.parentcategory) {
                    return CustomField.get(vm.post.parentcategory, vm.post.custom);
                } else {
                    if (category) {
                        return CustomField.get(category, vm.post.custom);
                    }
                }
                return $q.resolve();
            };
            getCustomFields().then(function(customFields) {
                if (customFields) {
                    vm.customFields = customFields;
                }
            });
            vm.showCategoryDialog = function() {
                Category.openCategoryChooser()
                    .then(function(result) {
                        $log.info(result);
                        vm.post.category = result.selected;
                        vm.post.categorySlug = result.breadcrumbs;
                        vm.post.parentcategory = result.categories[0]._id;
                        return getCustomFields(vm.post.parentcategory);
                    })
                    .then(function(customFields) {
                        $log.info(customFields);
                        vm.customFields = customFields;
                    });
            };

            vm.setMainImage = function(index) {
                vm.post.images.forEach(function(image, i) {
                    if (i === index) {
                        image.isMain = true;
                    } else {
                        image.isMain = false;
                    }
                });
            };

            //handle the image upload
            var uploadFile = function(file) {
                var nextImagePosition = vm.post.images.length;
                pendingImages = pendingImages + 1;
                vm.post.images.push({
                    loading: true,
                    progress: 0
                });

                var success = function(image) {
                    if (nextImagePosition === 0) {
                        image.isMain = true;
                    }
                    vm.post.images[nextImagePosition] = image;
                    pendingImages = pendingImages - 1;
                    if (makeUpload && pendingImages === 0) {
                        vm.create($scope.createPostForm);
                    }
                };
                var error = function() {
                    pendingImages = pendingImages - 1;
                    vm.post.images.splice(nextImagePosition, 1);
                };
                var progress = function(event) {
                    var progressPercentage = parseInt(100 * event.loaded / event.total);
                    vm.post.images[nextImagePosition].progress = progressPercentage;
                };
                File.create(file).then(success, error, progress);
            };

            vm.uploadFiles = function(files) {
                files.forEach(function(file) {
                    uploadFile(file);
                });
                vm.files = null;
            };

            vm.getFileByIndex = function(index) {
                var list = Post.images.get();
                return list[index];
            };
            vm.deleteFile = function(image, index) {
                if (image.pending) {
                    vm.post.images.splice(index, 1);
                } else {
                    File.delete(image._id).then(function() {
                        vm.post.images.splice(index, 1);
                    });
                }
            };
            vm.create = function(form) {
                var confirm = $mdDialog
                    .confirm()
                    .title('Aun te faltan las imagenes')
                    .textContent('Seguro que quieres continuar sin agregar las imagenes, tus articulos son mas visibles si las agregas')
                    .ariaLabel('Aun te faltan las imagenes')
                    .ok('Continuar')
                    .cancel('Si, agregar imagenes');
                var askForAuthenticationDialog = {
                    templateUrl:
            'main/post/create/ask.authenticate.dialog/ask.for.authentication.dialog.tpl.html',
                    controller: 'AskAuthenticationController as vm'
                };

                //manual check if the form is valid, the category and conditionn is choosed
                var isValid = form.$valid && vm.post.category && vm.post.condition;

                if (isValid) {
                    var promise;
                    if (pendingImages > 0) {
                        makeUpload = true;
                        return $mdToast.show($mdToast
                            .simple()
                            .textContent('Aún se esta subiendo algunas imagenes, por favor espere')
                            .hideDelay(6000));
                    }
                    //ask for image
                    if (vm.post.images.length === 0 && !$stateParams.grabar) {
                        //ask for image if not image is present
                        promise = $mdDialog.show(confirm);
                    } else {
                        promise = $q.resolve();
                    }

                    promise
                        .then(function() {
                            if (!$auth.isAuthenticated()) {
                                StateQueue.push({
                                    name: $state.current.name,
                                    params: { grabar: true },
                                    sticky: true
                                });
                                if (isMobile) {
                                    $state.go('signinquestion');
                                } else {
                                    $mdDialog.show(askForAuthenticationDialog);
                                }
                                return $q.reject();
                            }
                            vm.isLoading = true;
                            var promise;
                            var post;
                            // add main image
                            moveImagesArray();

                            if (isEditing) {
                                post = angular.copy(vm.post);
                                post.images = post.images.reduce(function (b, a) {
                                    b.push(a._id);
                                    return b;
                                }, []);

                                // Force a patch request
                                promise = post.$save(Object.keys(post)).$asPromise();
                            } else {
                                post = angular.copy(vm.post);
                                post.images = post.images.reduce(function (b, a) {
                                    b.push(a._id);
                                    return b;
                                }, []);
                                promise = Post.$build(post)
                                    .$save()
                                    .$asPromise();
                            }
                            return promise;
                        })
                        .then(function(post) {
                            vm.post.$reset();
                            vm.isLoading = false;
                            if (isEditing) {
                                $state.go('main.profile.products');
                            } else {
                                $state.go('main.profile.products');
                                // $state.go('main.post.success', {
                                //     id: post._id
                                // });
                            }
                            $mdToast.show($mdToast
                                .simple()
                                .textContent(post.title + ' se ha publicado correctamente')
                                .hideDelay(6000));
                        })
                        .catch(function(error) {
                            vm.isLoading = false;
                            if (error.$response.data.name === 'E_USER_NOT_PHONE_VALIDATED') {
                                StateQueue.push({
                                    name: $state.current.name,
                                    params: { grabar: true },
                                    sticky: true
                                });
                                $state.go('main.profile.edit.phone');
                            }
                        });
                } else {
                    vm.showErrors = true;
                }
            };
            vm.checkSuggestion = function() {};
            vm.suggestion = {
                accept: function() {
                    vm.post.title = vm.suggestion.term;
                    vm.suggestion.term = null;
                },
                check: function() {
                    Suggestion.spellCheck(vm.post.title).then(function(suggestion) {
                        if (suggestion.correct) {
                            vm.suggestion.term = null;
                        } else {
                            vm.suggestion.term = suggestion.words;
                        }
                    });
                },
                term: null
            };
            if ($stateParams.grabar) {
                $timeout(function() {
                    var imageList = Post.images.get();
                    if (imageList && imageList.length > 0) {
                        vm.post.images = [];
                        vm.uploadFiles(imageList);
                    }
                    vm.create($scope.createPostForm);
                });
            }
            var stateChangeEvent = $rootScope.$on('$stateChangeSuccess', function() {
                if (picturePanel) {
                    picturePanel.close();
                    // announcer.emit(Announcer.types.FULL_SCREEN_MODE_NO_TOOLBAR, true);
                }
            });
            $scope.$on('$destroy', function() {
                stateChangeEvent();
            });
        }]);
}());
